<p-dialog header="Verificación de identidad" [(visible)]="visible" [modal]="true"
  [style]="{width: '420px'}" [closable]="true" (onHide)="close(false)" [dismissableMask]="true">

  <div class="space-y-5">
    <!-- Descripción -->
    <p class="text-sm text-gray-500 text-center">
      Hemos enviado un código de verificación vía WhatsApp, SMS y/o correo electrónico.
    </p>

    <!-- Inputs OTP -->
    <div id="c" class="flex justify-center gap-3">
      @for (item of OTPForm?.controls | keys; track item; let i = $index) {
        <input maxlength="1" [formControl]="getFormControl(item)" [id]="'otp_' + i" [name]="'ctrl_' + i"
          class="otp-input w-14 h-14 text-center text-xl font-semibold rounded-lg border border-gray-300 focus:border-vivid-royal-500 focus:ring-2 focus:ring-vivid-royal-200 outline-none transition-colors"
          type="text" inputmode="numeric" autocomplete="one-time-code"
          (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event, i)" />
      }
    </div>

    <!-- Mensaje de estado -->
    @if (otpMessage) {
      <p class="text-sm text-center" [ngClass]="otpError ? 'text-red-500' : 'text-green-600'">
        {{ otpMessage }}
      </p>
    }

    <!-- Reenvío -->
    <div class="text-center text-sm text-gray-500">
      @if (!canResend) {
        <p>Podrás reenviar el código en <span class="font-semibold">{{ timer }}s</span></p>
      } @else {
        <button type="button" class="text-vivid-royal-600 hover:underline font-medium" (click)="resend()">
          Reenviar código
        </button>
      }
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button pButton label="Cancelar" class="p-button-sm p-button-text" (click)="close(false)"></button>
      <button pButton [label]="isValidating ? 'Verificando...' : 'Verificar'" class="p-button-sm"
        [icon]="isValidating ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="isValidating || !otp || otp.length < 4" (click)="verifyOTP()"></button>
    </div>
  </ng-template>
</p-dialog>
